import { CHANGE_LANGUAGE_TOGGLE } from "../actions/changeLanguageToggle";

export default function (state = "en", action: any) {
  switch (action.type) {
    case CHANGE_LANGUAGE_TOGGLE:
      return action.payload.language;
    default:
      return state;
  }
}
